import { Engagement } from '@ms/odsp-utilities/lib/logging/events/Engagement.event';
import { IEngagementExtraData, ShareType, ClientId, Mode, SharingAudience } from '../interfaces/SharingInterfaces';
import * as PeoplePickerHelper from "./PeoplePickerHelper";
import { IPerson } from '@ms/odsp-datasources/lib/PeoplePicker';
import { IManager } from '@ms/telemetry-manager/lib/Manager';

const ENGAGEMENT_PREFIX = 'ShareV3';

export class EngagementHelper {
    private _manager: IManager;

    constructor(manager?: IManager) {
        this._manager = manager;
    }

    public opened(extraData: IEngagementExtraData) {
        this.log('Opened', extraData);
    }

    public linkSettingsOpened(extraData: IEngagementExtraData) {
        this.log('LinkSettings.Opened', extraData);
    }

    public linkSettingsApplyClicked(extraData: IEngagementExtraData) {
        this.log('LinkSettings.ApplyClicked', extraData);
    }

    public linkSettingsCancelClicked(extraData: IEngagementExtraData) {
        this.log('LinkSettings.CancelClicked', extraData);
    }

    public linkSettingsLearnMoreClicked(extraData: IEngagementExtraData) {
        this.log('LinkSettings.LearnMoreClicked', extraData);
    }

    public manageAccessOpened(extraData: IEngagementExtraData) {
        this.log('ManageAccess.Opened', extraData);
    }

    public shareCompleted(extraData: IEngagementExtraData) {
        this.log('Completed', extraData);
    }

    public sendACopyClicked(extraData: IEngagementExtraData) {
        this.log('SendACopy.Clicked', extraData);
    }

    public sendACopyOfficeClicked(extraData: IEngagementExtraData) {
        this.log('SendACopy.OfficeClicked', extraData);
    }

    public sendACopyPdfClicked(extraData: IEngagementExtraData) {
        this.log('SendACopy.PdfClicked', extraData);
    }

    public whoElseHasAccessClicked(extraData: IEngagementExtraData) {
        this.log('WhoElseHasAccess.Clicked', extraData);
    }

    public shareTargets(extraData: IEngagementExtraData) {
        this.log('ShareTargets', extraData);
    }

    public trackClickThru(extraData: IEngagementExtraData) {
        this.log('ClickThruTracker', extraData);
    }

    public externalSharingCslError(extraData: IEngagementExtraData) {
        this.log('externalSharingCslError', extraData);
    }

    public copyLinkInterruptOpened(extraData: IEngagementExtraData) {
        this.log('copyLinkInterruptOpened', extraData);
    }

    public copyLinkInterruptEditLinkChosen(extraData: IEngagementExtraData) {
        this.log('copyLinkInterruptEditLinkChosen', extraData);
    }

    public copyLinkInterruptExistingLinkChosen(extraData: IEngagementExtraData) {
        this.log('copyLinkInterruptExistingLinkChosen', extraData);
    }

    public copyLinkInterruptCancelled(extraData: IEngagementExtraData) {
        this.log('copyLinkInterruptCancelled', extraData);
    }
    // Log how many linkedin suggestions are selected in people picker
    public peoplePickerLinkedinSuggestionSelected(extraData: IEngagementExtraData, suggestions: IPerson[]) {
        this.log('PeoplePicker.SuggestionSelected', { ...extraData, linkedinSuggestionsSelectedCount: PeoplePickerHelper.getLinkedInPeopleCount(suggestions) });
    }

    // Log how many linkedin suggestions are returned in people picker
    public peoplePickerLinkedinSuggestions(extraData: IEngagementExtraData, suggestions: IPerson[]) {
        this.log('PeoplePicker.Suggestions', { ...extraData, linkedinSuggestionsCount: PeoplePickerHelper.getLinkedInPeopleCount(suggestions) });
    }

    public log(eventName: string, extraData: IEngagementExtraData) {
        // Get string values of enums so charts are nicer.
        const friendlyExtraData = {
            ...extraData,
            clientId: ClientId[extraData.clientId],
            scenarioId: extraData.scenarioId,
            mode: Mode[extraData.mode],
            shareType: ShareType[extraData.shareType],
            audience: SharingAudience[extraData.audience],
            shareTargets: this._getFriendlyShareTargets(extraData.shareTargets)
        };

        const engagementPayload = {
            name: `${ENGAGEMENT_PREFIX}.${eventName}`,
            webTemplateId: extraData.webTemplateId ? extraData.webTemplateId.toString() : undefined,
            docId: extraData.itemUniqueId,
            extraData: friendlyExtraData
        };
        (this._manager ? Engagement.withManager(this._manager) : Engagement).logData(engagementPayload);
    }

    private _getFriendlyShareTargets(originalShareTargets: ShareType[]) {
        const friendlyShareTargets = [];

        if (originalShareTargets) {
            for (const shareTarget of originalShareTargets) {
                friendlyShareTargets.push(ShareType[shareTarget]);
            }
        }

        return friendlyShareTargets;
    }
}
